import styled from "styled-components";
import { Trans } from "@coworker/locales";
import { FC } from "react";
import FixaButton from "../../shared/wrappers/FixaButton/FixaButton";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  @media (max-width: 400px) {
    padding: 8px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
  text-align: center;
  padding: 32px 16px;
  @media (min-width: 800px) {
    min-width: 700px;
  }
`;

const Description = styled.p`
  text-align: center;
`;

const NoInsightsData: FC<{
  hasSearchedArticleNo: boolean;
  clearArticleSearchInputValue: () => void;
}> = ({ hasSearchedArticleNo, clearArticleSearchInputValue }) => (
  <Wrapper>
    <Container>
      <h2>
        <Trans>noInsightsDataString</Trans>
      </h2>
      {hasSearchedArticleNo ? (
        <>
          <Description>
            <Trans>noInsightsDataDescriptionString</Trans>
          </Description>
          <FixaButton onClick={clearArticleSearchInputValue}>
            <Trans>clearSearchString</Trans>
          </FixaButton>
        </>
      ) : (
        <Description>
          <Trans>noInsightsDataDescriptionString</Trans>
        </Description>
      )}
    </Container>
  </Wrapper>
);
export default NoInsightsData;
